import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=f10f42da&scoped=true"
import script from "./ProductActions.vue?vue&type=script&lang=ts"
export * from "./ProductActions.vue?vue&type=script&lang=ts"
import style0 from "./ProductActions.vue?vue&type=style&index=0&id=f10f42da&prod&lang=scss&scoped=true"
import style1 from "./ProductActions.vue?vue&type=style&index=1&id=f10f42da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10f42da",
  null
  
)

export default component.exports